// @core/api/endpoints/analytics/get_saved_query.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SavedQueryResponse,
} from '../../../types/analytics';

const BASE_PATH = '/analytics';

/**
 * Get saved query
 * Retrieves a saved analytics query configuration.
 */
export async function GetSavedQuery(
  query_id: string,
  options?: RequestOptions
): Promise<SavedQueryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/analytics/saved-queries/:query_id`;
  requestPath = requestPath.replace(':query_id', encodeURIComponent(query_id));
  const requestOptions = options;
  return client.get<SavedQueryResponse>(requestPath, { ...requestOptions });
}
